import React from "react";

const UltimoLogin = (props) => {

    let fechaLogOut  = props.ultimoIngreso && props.ultimoIngreso.FechaLogOut ? props.ultimoIngreso.FechaLogOut.substr(0,8) : null;
    let fechaLogin = props.ultimoIngreso && props.ultimoIngreso.FechaLogin ? props.ultimoIngreso.FechaLogin.substr(0,8) : null;
    let fechaCompletaIn = props.ultimoIngreso && props.ultimoIngreso.FechaIn ? new Date(props.ultimoIngreso.FechaIn) : null;
    let fechaCompletaOut = props.ultimoIngreso && props.ultimoIngreso.FechaOut ? new Date(props.ultimoIngreso.FechaOut) : null;


    return (
        <div className="row">
            <div className="col-xs-12">
                <h3 className="divisor-section">{"\u00DAltimo ingreso"}</h3>
            </div>
            <div className="col-md-12">
                {props.ultimoIngreso ? <div>
                    {(props.ultimoIngreso.DiasOffline != 0 || (props.ultimoIngreso.DiasOffline == 0 && props.ultimoIngreso.HoraLogin != props.ultimoIngreso.HoraLogOut) && props.ultimoIngreso.HoraLogin != null && props.ultimoIngreso.HoraLogOut != null &&  fechaCompletaIn < fechaCompletaOut) &&
                        (<div>
                        <p>{props.ultimoIngreso.NombreDiaLogin + " " + fechaLogOut + " desde las " + props.ultimoIngreso.HoraLogin + " hasta las " + props.ultimoIngreso.HoraLogOut}</p>
                        <label className="label-secondary">{"(Hace " + props.ultimoIngreso.DiasOffline + " dias)"}</label>
                        </div>)
                    }

                    {(props.ultimoIngreso.HoraLogin != null && props.ultimoIngreso.HoraLogOut == null) &&
                        (<div>
                        <p>{props.ultimoIngreso.NombreDiaLogin + " " + fechaLogin + " desde las " + props.ultimoIngreso.HoraLogin + " - conectado actualmente"}</p>
                        <label className="label-secondary">{"(Hace " + props.ultimoIngreso.DiasOffline + " dias)"}</label>
                        </div>)
                    }
                    
                    {((fechaCompletaIn != null) && (fechaCompletaIn > fechaCompletaOut)) &&
                        (<div>
                        <p>{props.ultimoIngreso.NombreDiaLogin + " " + fechaLogOut + " desde las " + props.ultimoIngreso.HoraLogin + " - conectado actualmente"}</p>
                        <label className="label-secondary">{"(Hace " + props.ultimoIngreso.DiasOffline + " dias)"}</label>
                        </div>)
                    }
                       

                    {/* {(props.ultimoIngreso.DiasOffline == 0 && props.ultimoIngreso.HoraLogin == props.ultimoIngreso.HoraLogOut) &&
                        (<div>
                        <p>{props.ultimoIngreso.NombreDiaLogin + " a las " + props.ultimoIngreso.HoraLogin}</p>
                        </div>)
                    } */}

                    <p>Via <b>{props.ultimoIngreso.Plataforma}</b></p>
                </div> : <p>{"El usuario no ha iniciado sesi\u00F3n en la plataforma"}</p>}
            </div>
        </div>
    );
}

export default UltimoLogin;